import React from 'react';
import { Card, Col, Spin, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

interface KPICardProps {
    title: string;
    value: string | number;
    change?: number;           // phần trăm thay đổi
    suffix?: string;
    prefix?: React.ReactNode;
    valueStyle?: React.CSSProperties;
    isLoading?: boolean;
}

const KPICard: React.FC<KPICardProps> = ({
    title,
    value,
    change,
    suffix = '',
    prefix,
    valueStyle,
    isLoading = false,
}) => {
    const isPositive = change !== undefined && change >= 0;

    return (
        <Col xs={24} sm={12} lg={8} xl={6} xxl={4}>
            <Spin spinning={isLoading}>
                <Card style={{ height: '100%' }}>
                    <Statistic
                        title={title}
                        value={value}
                        prefix={prefix}
                        suffix={suffix}
                        valueStyle={{
                            color: isPositive ? '#13C2C2' : '#FF4D4F',
                            fontSize: '28px',
                            fontWeight: 600,
                            ...valueStyle,
                        }}
                        formatter={(value) => value}
                    />

                    {change !== undefined && (
                        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center' }}>
                            <span
                                style={{
                                    color: isPositive ? '#13C2C2' : '#FF4D4F',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                }}
                            >
                                {isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                                {Math.round(Math.abs(change))}%
                            </span>
                            <span style={{ marginLeft: 8, color: '#8C8C8C', fontSize: '13px' }}>
                                so với kỳ trước
                            </span>
                        </div>
                    )}
                </Card>
            </Spin>
        </Col>
    );
};

export { KPICard };